import { ThemeRoutes } from "app/shared"

export const themeSettingsMenu = [{
    key: "general",
    text: "Genel Özellikler",
    description: "Aşağıdan SEO işlemleri için başlıkların ön ve arkasına gelecek metni ve logo ayarlarını yapılandırabilirsiniz.",
    icon: "fas fa-cogs"
},
{
    key: "color",
    text: "Renk Yönetimi",
    description: "Aşağıdan koyu ve açık tema'ların renk ayarlarını yapılandırabilirsiniz.",
    icon: "fas fa-tint"
},
{
    key: "routes",
    text: "Sayfa Ayarları",
    description: "Aşağıdan statik (varsayılan) sayfaların post karşılıklarını ayarlayabilirsiniz.",
    icon: "fas fa-train"
},
{
    key: "locale",
    text: "Metinler",
    icon: "fas fa-font"
},
{
    key: "social",
    text: "Sosyal Medya Adresleri",
    icon: "fab fa-twitter"
},
{
    key: "languages",
    text: "Dil Seçenekleri",
    icon: "fas fa-globe"
}]

export const staticRoutes = [{
    key: ThemeRoutes.Home,
    text: "Anasayfa"
},
{
    key: ThemeRoutes.Announcements,
    text: "Duyurular"
},
{
    key: ThemeRoutes.PrivacyPolicy,
    text: "Gizlilik Politikası"
},
{
    key: ThemeRoutes.CookiePolicy,
    text: "Çerez Yönetimi"
},
{
    key: ThemeRoutes.Clarification,
    text: "Aydınlatma Metni"
},
{
    key: ThemeRoutes.EventList,
    text: "Etkinlik Listesi"
},
{
    key: ThemeRoutes.Event,
    text: "Etkinlik Detay"
},
{
    key: ThemeRoutes.ArchiveEvent,
    text: "Etkinlik Arşiv Detay"
},
{
    key: ThemeRoutes.Qr,
    text: "QR Kodu"
},
{
    key: ThemeRoutes.SignIn,
    text: "Giriş"
},
{
    key: ThemeRoutes.SignUp,
    text: "Üye Ol"
},
{
    key: ThemeRoutes.ForgotPassword,
    text: "Şifremi Unuttum"
},
{
    key: ThemeRoutes.LibraryAppointment,
    text: "Kütüphane Randevu"
},
{
    key: ThemeRoutes.AccountProfile,
    text: "Profil Bilgilerim"
},
{
    key: ThemeRoutes.AccountAppointments,
    text: "Randevularım"
},
{
    key: ThemeRoutes.AccountEmail,
    text: "E-Posta Adresim"
},
{
    key: ThemeRoutes.AccountPhone,
    text: "Telefon Numaram"
},
{
    key: ThemeRoutes.AccountPassword,
    text: "Şifre Bilgilerim"
}, {
    key: ThemeRoutes.ArtChildrenEventList,
    text: "Çocuk Sanat Festivali Etkinlik Listesi"
}, {
    key: ThemeRoutes.ArtChildrenGallery,
    text: "Çocuk Sanat Festivali Galeri"
} , {
    key: ThemeRoutes.Calendar,
    text: "Takvim"
}]

export const defaultLanguages = ["en", "tr", "fr", "de", "nl", "ar", "ru", "uk", "es", "zh"]

export const defaultThemeLanguage = [{ name: "EN", nativeName: "English", code: "en" }];